"use client";

import { c as _c } from "react/compiler-runtime";
import type { FUSportsLivescoreEvent, SearchEntityResult } from "fansunited-data-layer";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { PeriodsMatchRow } from "./PeriodsMatchRow";
interface BasketballMatchRowProps {
  event: FUSportsLivescoreEvent;
  entities: Record<string, SearchEntityResult>;
}
export function BasketballMatchRow(t0) {
  const $ = _c(4);
  const {
    event,
    entities
  } = t0;
  const labels = useLabels();
  let t1;
  if ($[0] !== entities || $[1] !== event || $[2] !== labels.livescore.quarter) {
    t1 = <PeriodsMatchRow event={event} entities={entities} sport="basketball" periodLabel={labels.livescore.quarter} maxRegulationPeriods={4} />;
    $[0] = entities;
    $[1] = event;
    $[2] = labels.livescore.quarter;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}